"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[436],{

/***/ 64370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ Toast_Toast; }
});

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Dimensions/index.js
var Dimensions = __webpack_require__(95998);
// EXTERNAL MODULE: ./node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(20129);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@tamagui/helpers/dist/esm/index.mjs + 5 modules
var esm = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/@tamagui/stacks/dist/esm/ThemeableStack.mjs + 1 modules
var ThemeableStack = __webpack_require__(90099);
// EXTERNAL MODULE: ./node_modules/@tamagui/text/dist/esm/SizableText.mjs
var SizableText = __webpack_require__(18796);
// EXTERNAL MODULE: ./node_modules/@tamagui/use-controllable-state/dist/esm/useControllableState.mjs
var useControllableState = __webpack_require__(81430);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tamagui/toast/dist/esm/constants.mjs
var constants = __webpack_require__(20335);
// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs + 1 modules
var dist_esm = __webpack_require__(75425);
// EXTERNAL MODULE: ./node_modules/@tamagui/start-transition/dist/esm/index.mjs
var start_transition_dist_esm = __webpack_require__(28031);
// EXTERNAL MODULE: ./node_modules/@tamagui/portal/dist/esm/index.mjs + 2 modules
var portal_dist_esm = __webpack_require__(86660);
// EXTERNAL MODULE: ./node_modules/@tamagui/visually-hidden/dist/esm/VisuallyHidden.mjs
var VisuallyHidden = __webpack_require__(68648);
// EXTERNAL MODULE: ./node_modules/@tamagui/toast/dist/esm/ToastProvider.mjs + 2 modules
var ToastProvider = __webpack_require__(2263);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@tamagui/toast/dist/esm/ToastAnnounce.mjs








const ToastAnnounceExcludeFrame = (0,cjs.styled)(cjs.Stack, {
    name: "ToastAnnounceExclude"
  }),
  ToastAnnounceExclude = react.forwardRef((props, forwardedRef) => {
    const {
      altText,
      ...announceExcludeProps
    } = props;
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ToastAnnounceExcludeFrame, {
      "data-toast-announce-exclude": "",
      "data-toast-announce-alt": altText || void 0,
      ...announceExcludeProps,
      ref: forwardedRef
    });
  }),
  ToastAnnounce = props => {
    const {
        __scopeToast,
        children,
        ...announceProps
      } = props,
      context = (0,ToastProvider/* useToastProviderContext */.jz)(__scopeToast),
      [renderAnnounceText, setRenderAnnounceText] = react.useState(!1),
      [isAnnounced, setIsAnnounced] = react.useState(!1);
    return useNextFrame(() => {
      (0,start_transition_dist_esm/* startTransition */.L)(() => {
        setRenderAnnounceText(!0);
      });
    }), react.useEffect(() => {
      const timer = setTimeout(() => setIsAnnounced(!0), 1e3);
      return () => clearTimeout(timer);
    }, []), isAnnounced ? null : /* @__PURE__ */(0,jsx_runtime.jsx)(portal_dist_esm/* Portal */.h_, {
      asChild: !0,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(VisuallyHidden/* VisuallyHidden */.T, {
        ...announceProps,
        children: renderAnnounceText && /* @__PURE__ */(0,jsx_runtime.jsxs)(cjs.Text, {
          children: [context.label, " ", children]
        })
      })
    });
  };
function useNextFrame(callback = () => {}) {
  const fn = (0,cjs.useEvent)(callback);
  (0,dist_esm/* useIsomorphicLayoutEffect */.LI)(() => {
    let raf1 = 0,
      raf2 = 0;
    return raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(fn);
    }), () => {
      cancelAnimationFrame(raf1), cancelAnimationFrame(raf2);
    };
  }, [fn]);
}

//# sourceMappingURL=ToastAnnounce.mjs.map

// EXTERNAL MODULE: ./node_modules/@tamagui/use-presence/dist/esm/index.mjs + 2 modules
var use_presence_dist_esm = __webpack_require__(61360);
// EXTERNAL MODULE: ./node_modules/@tamagui/compose-refs/dist/esm/compose-refs.mjs
var compose_refs = __webpack_require__(94030);
// EXTERNAL MODULE: ./node_modules/@tamagui/dismissable/dist/esm/index.mjs + 3 modules
var dismissable_dist_esm = __webpack_require__(69438);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/PanResponder/index.js + 2 modules
var PanResponder = __webpack_require__(64645);
// EXTERNAL MODULE: ./node_modules/@tamagui/toast/dist/esm/ToastViewport.mjs + 1 modules
var ToastViewport = __webpack_require__(7797);
;// CONCATENATED MODULE: ./node_modules/@tamagui/toast/dist/esm/ToastImpl.mjs
/* provided dependency */ var process = __webpack_require__(34155);















const ToastImplFrame = (0,cjs.styled)(ThemeableStack/* ThemeableStack */.K, {
    name: "ToastImpl",
    focusable: !0,
    variants: {
      unstyled: {
        false: {
          focusStyle: {
            outlineStyle: "solid",
            outlineWidth: 2,
            outlineColor: "$outlineColor"
          },
          backgroundColor: "$color6",
          borderRadius: "$10",
          paddingHorizontal: "$5",
          paddingVertical: "$2",
          marginHorizontal: "auto",
          marginVertical: "$1"
        }
      }
    },
    defaultVariants: {
      unstyled: process.env.TAMAGUI_HEADLESS === "1"
    }
  }),
  {
    Provider: ToastInteractiveProvider,
    useStyledContext: useToastInteractiveContext
  } = (0,cjs.createStyledContext)({
    onClose() {}
  }),
  ToastImpl = react.forwardRef((props, forwardedRef) => {
    const {
        __scopeToast,
        type = "foreground",
        duration: durationProp,
        open,
        onClose,
        onEscapeKeyDown,
        onPause,
        onResume,
        onSwipeStart,
        onSwipeMove,
        onSwipeCancel,
        onSwipeEnd,
        viewportName = "default",
        ...toastProps
      } = props,
      isPresent = (0,use_presence_dist_esm/* useIsPresent */.hO)(),
      context = (0,ToastProvider/* useToastProviderContext */.jz)(__scopeToast),
      [node, setNode] = react.useState(null),
      composedRefs = (0,compose_refs/* useComposedRefs */.ex)(forwardedRef, node2 => setNode(node2)),
      duration = durationProp || context.duration,
      closeTimerStartTimeRef = react.useRef(0),
      closeTimerRemainingTimeRef = react.useRef(duration),
      closeTimerRef = react.useRef(0),
      {
        onToastAdd,
        onToastRemove
      } = context,
      viewport = react.useMemo(() => context.viewports[viewportName], [context.viewports, viewportName]),
      handleClose = (0,cjs.useEvent)(() => {
        isPresent && (dist_esm/* isWeb */.$L && node?.contains(document.activeElement) && viewport?.focus(), onClose());
      }),
      startTimer = react.useCallback(duration2 => {
        !duration2 || duration2 === Number.POSITIVE_INFINITY || (clearTimeout(closeTimerRef.current), closeTimerStartTimeRef.current = ( /* @__PURE__ */new Date()).getTime(), closeTimerRef.current = setTimeout(handleClose, duration2));
      }, [handleClose]),
      handleResume = react.useCallback(() => {
        startTimer(closeTimerRemainingTimeRef.current), onResume?.();
      }, [onResume, startTimer]),
      handlePause = react.useCallback(() => {
        const elapsedTime = ( /* @__PURE__ */new Date()).getTime() - closeTimerStartTimeRef.current;
        closeTimerRemainingTimeRef.current = closeTimerRemainingTimeRef.current - elapsedTime, window.clearTimeout(closeTimerRef.current), onPause?.();
      }, [onPause]);
    react.useEffect(() => {
      if (dist_esm/* isWeb */.$L && viewport) return viewport.addEventListener(ToastViewport/* VIEWPORT_PAUSE */.hu, handlePause), viewport.addEventListener(ToastViewport/* VIEWPORT_RESUME */.AR, handleResume), () => {
        viewport.removeEventListener(ToastViewport/* VIEWPORT_PAUSE */.hu, handlePause), viewport.removeEventListener(ToastViewport/* VIEWPORT_RESUME */.AR, handleResume);
      };
    }, [viewport, duration, onPause, onResume, startTimer]), react.useEffect(() => {
      open && !context.isClosePausedRef.current && startTimer(duration);
    }, [open, duration, context.isClosePausedRef, startTimer]), react.useEffect(() => (onToastAdd(), () => onToastRemove()), [onToastAdd, onToastRemove]);
    const announceTextContent = react.useMemo(() => dist_esm/* isWeb */.$L && node ? getAnnounceTextContent(node) : null, [node]),
      isHorizontalSwipe = ["left", "right", "horizontal"].includes(context.swipeDirection),
      {
        animationDriver
      } = (0,cjs.useConfiguration)();
    if (!animationDriver) throw new Error("Must set animations in tamagui.config.ts");
    const {
        useAnimatedNumber,
        useAnimatedNumberStyle
      } = animationDriver,
      animatedNumber = useAnimatedNumber(0),
      AnimatedView = animationDriver.NumberView ?? animationDriver.View ?? cjs.Stack,
      animatedStyles = useAnimatedNumberStyle(animatedNumber, val => {
        "worklet";

        return {
          transform: [isHorizontalSwipe ? {
            translateX: val
          } : {
            translateY: val
          }]
        };
      }),
      panResponder = react.useMemo(() => PanResponder/* default.create */.Z.create({
        onMoveShouldSetPanResponder: (e, gesture) => shouldGrantGestureMove(context.swipeDirection, gesture) ? (onSwipeStart?.(e), !0) : !1,
        onPanResponderGrant: e => {
          dist_esm/* isWeb */.$L || handlePause?.();
        },
        onPanResponderMove: (e, gesture) => {
          const {
              x,
              y
            } = getGestureDistance(context.swipeDirection, gesture),
            delta = {
              x,
              y
            };
          animatedNumber.setValue(isHorizontalSwipe ? x : y, {
            type: "direct"
          }), isDeltaInDirection(delta, context.swipeDirection, context.swipeThreshold) && onSwipeEnd?.(e), onSwipeMove?.(e);
        },
        onPanResponderEnd: (e, {
          dx,
          dy
        }) => {
          isDeltaInDirection({
            x: dx,
            y: dy
          }, context.swipeDirection, context.swipeThreshold) || (dist_esm/* isWeb */.$L || handleResume?.(), onSwipeCancel?.(e), animatedNumber.setValue(0, {
            type: "spring"
          }));
        }
      }), [handlePause, handleResume]),
      themeName = (0,cjs.useThemeName)();
    return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [announceTextContent && /* @__PURE__ */(0,jsx_runtime.jsx)(ToastAnnounce, {
        __scopeToast,
        role: "status",
        "aria-live": type === "foreground" ? "assertive" : "polite",
        "aria-atomic": !0,
        children: announceTextContent
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(portal_dist_esm/* PortalItem */.b5, {
        hostName: viewportName ?? "default",
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastInteractiveProvider, {
          scope: __scopeToast,
          onClose: () => {
            handleClose();
          },
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(dismissable_dist_esm/* Dismissable */.XA, {
            onEscapeKeyDown: (0,esm/* composeEventHandlers */.Mj)(onEscapeKeyDown, () => {
              context.isFocusedToastEscapeKeyDownRef.current || handleClose(), context.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(cjs.Theme, {
              forceClassName: !0,
              name: themeName,
              children: /* @__PURE__ */(0,jsx_runtime.jsx)(AnimatedView, {
                ...panResponder?.panHandlers,
                style: [{
                  margin: "auto"
                }, animatedStyles],
                children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastProvider/* Collection.ItemSlot */.FE.ItemSlot, {
                  __scopeCollection: __scopeToast || constants/* TOAST_CONTEXT */.B,
                  children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastImplFrame, {
                    role: "status",
                    "aria-live": "off",
                    "aria-atomic": !0,
                    "data-state": open ? "open" : "closed",
                    "data-swipe-direction": context.swipeDirection,
                    pointerEvents: "auto",
                    touchAction: "none",
                    userSelect: "none",
                    ...toastProps,
                    ref: composedRefs,
                    ...(dist_esm/* isWeb */.$L && {
                      onKeyDown: (0,esm/* composeEventHandlers */.Mj)(props.onKeyDown, event => {
                        event.key === "Escape" && (onEscapeKeyDown?.(event), onEscapeKeyDown?.(event), event.defaultPrevented || (context.isFocusedToastEscapeKeyDownRef.current = !0, handleClose()));
                      })
                    })
                  })
                })
              })
            })
          })
        }, props.id)
      })]
    });
  });
ToastImpl.propTypes = {
  type(props) {
    if (props.type && !["foreground", "background"].includes(props.type)) {
      const error = `Invalid prop \`type\` supplied to \`${constants/* TOAST_NAME */.F}\`. Expected \`foreground | background\`.`;
      return new Error(error);
    }
    return null;
  }
};
const isDeltaInDirection = (delta, direction, threshold = 0) => {
  const deltaX = Math.abs(delta.x),
    deltaY = Math.abs(delta.y),
    isDeltaX = deltaX > deltaY;
  return direction === "left" || direction === "right" || direction === "horizontal" ? isDeltaX && deltaX > threshold : !isDeltaX && deltaY > threshold;
};
function getAnnounceTextContent(container) {
  if (!dist_esm/* isWeb */.$L) return "";
  const textContent = [];
  return Array.from(container.childNodes).forEach(node => {
    if (node.nodeType === node.TEXT_NODE && node.textContent && textContent.push(node.textContent), isHTMLElement(node)) {
      const isHidden = node.ariaHidden || node.hidden || node.style.display === "none",
        isExcluded = node.dataset.toastAnnounceExclude === "";
      if (!isHidden) if (isExcluded) {
        const altText = node.dataset.toastAnnounceAlt;
        altText && textContent.push(altText);
      } else textContent.push(...getAnnounceTextContent(node));
    }
  }), textContent;
}
function isHTMLElement(node) {
  return node.nodeType === node.ELEMENT_NODE;
}
const GESTURE_GRANT_THRESHOLD = 10,
  shouldGrantGestureMove = (dir, {
    dx,
    dy
  }) => (dir === "horizontal" || dir === "left") && dx < -GESTURE_GRANT_THRESHOLD || (dir === "horizontal" || dir === "right") && dx > GESTURE_GRANT_THRESHOLD || (dir === "vertical" || dir === "up") && dy > -GESTURE_GRANT_THRESHOLD || (dir === "vertical" || dir === "down") && dy < GESTURE_GRANT_THRESHOLD,
  getGestureDistance = (dir, {
    dx,
    dy
  }) => {
    let y = 0,
      x = 0;
    return dir === "horizontal" ? x = dx : dir === "left" ? x = Math.min(0, dx) : dir === "right" ? x = Math.max(0, dx) : dir === "vertical" ? y = dy : dir === "up" ? y = Math.min(0, dy) : dir === "down" && (y = Math.max(0, dy)), {
      x,
      y
    };
  };

//# sourceMappingURL=ToastImpl.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/toast/dist/esm/Toast.mjs
/* provided dependency */ var Toast_process = __webpack_require__(34155);













const TITLE_NAME = "ToastTitle",
  ToastTitle = (0,cjs.styled)(SizableText/* SizableText */.J, {
    name: TITLE_NAME,
    variants: {
      unstyled: {
        false: {
          color: "$color",
          size: "$4"
        }
      }
    },
    defaultVariants: {
      unstyled: Toast_process.env.TAMAGUI_HEADLESS === "1"
    }
  });
ToastTitle.displayName = TITLE_NAME;
const DESCRIPTION_NAME = "ToastDescription",
  ToastDescription = (0,cjs.styled)(SizableText/* SizableText */.J, {
    name: DESCRIPTION_NAME,
    variants: {
      unstyled: {
        false: {
          color: "$color11",
          size: "$1"
        }
      }
    },
    defaultVariants: {
      unstyled: Toast_process.env.TAMAGUI_HEADLESS === "1"
    }
  });
ToastDescription.displayName = DESCRIPTION_NAME;
const ACTION_NAME = "ToastAction",
  ToastAction = react.forwardRef((props, forwardedRef) => {
    const {
      altText,
      ...actionProps
    } = props;
    return altText ? /* @__PURE__ */(0,jsx_runtime.jsx)(ToastAnnounceExclude, {
      altText,
      asChild: !0,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastClose, {
        ...actionProps,
        ref: forwardedRef
      })
    }) : null;
  });
ToastAction.propTypes = {
  altText(props) {
    return props.altText ? null : new Error(`Missing prop \`altText\` expected on \`${ACTION_NAME}\``);
  }
};
ToastAction.displayName = ACTION_NAME;
const CLOSE_NAME = "ToastClose",
  ToastCloseFrame = (0,cjs.styled)(ThemeableStack/* ThemeableStack */.K, {
    name: CLOSE_NAME,
    tag: "button"
  }),
  ToastClose = react.forwardRef((props, forwardedRef) => {
    const {
        __scopeToast,
        ...closeProps
      } = props,
      interactiveContext = useToastInteractiveContext(__scopeToast);
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ToastAnnounceExclude, {
      asChild: !0,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastCloseFrame, {
        accessibilityLabel: "Dialog Close",
        ...closeProps,
        ref: forwardedRef,
        onPress: (0,esm/* composeEventHandlers */.Mj)(props.onPress, interactiveContext.onClose)
      })
    });
  });
ToastClose.displayName = CLOSE_NAME;
const ToastComponent = ToastImplFrame.styleable((props, forwardedRef) => {
  const {
      forceMount,
      open: openProp,
      defaultOpen,
      onOpenChange,
      ...toastProps
    } = props,
    [open, setOpen] = (0,useControllableState/* useControllableState */.T)({
      prop: openProp,
      defaultProp: defaultOpen ?? !0,
      onChange: onOpenChange,
      strategy: "most-recent-wins"
    }),
    id = react.useId(),
    onPause = (0,cjs.useEvent)(props.onPause),
    onResume = (0,cjs.useEvent)(props.onResume);
  return forceMount || open ? /* @__PURE__ */(0,jsx_runtime.jsx)(ToastImpl, {
    id,
    open,
    ...toastProps,
    ref: forwardedRef,
    onClose: () => setOpen(!1),
    onPause,
    onResume,
    onSwipeEnd: (0,esm/* composeEventHandlers */.Mj)(props.onSwipeEnd, event => {
      setOpen(!1);
    })
  }) : null;
});
ToastComponent.displayName = constants/* TOAST_NAME */.F;
const Toast = (0,esm/* withStaticProperties */.$e)(ToastComponent, {
  Title: ToastTitle,
  Description: ToastDescription,
  Action: ToastAction,
  Close: ToastClose
});

//# sourceMappingURL=Toast.mjs.map

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/tokens.js
var tokens = __webpack_require__(61274);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 4 modules
var IconButton = __webpack_require__(41538);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Toast/Toast.js









var toastTokens = Components/* tokens.toast */.T.toast, Toast_Toast = function(param) {
    var message = param.message, _duration = param.duration, duration = _duration === void 0 ? 3e3 : _duration, analyticsName = param.analyticsName, trackImpression = param.trackImpression, onOpenChange = param.onOpenChange, isOpen = param.isOpen, _isSuccess = param.isSuccess, isSuccess = _isSuccess === void 0 ? !1 : _isSuccess, _hasError = param.hasError, hasError = _hasError === void 0 ? !1 : _hasError, onClose = param.onClose;
    var handleToastOpenChange = function handleToastOpenChange(open) {
        open || (onClose === null || onClose === void 0 ? void 0 : onClose()), onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(open);
    };
    var ref = Dimensions/* default.get */.Z.get("window"), screenWidth = ref.width, width = screenWidth * 0.95;
    var getBackgroundColor = function() {
        return hasError ? toastTokens.color.background.error : isSuccess ? toastTokens.color.background.success : toastTokens.color.background.default;
    };
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Toast, {
        zIndex: 1e3,
        open: isOpen,
        onOpenChange: handleToastOpenChange,
        animation: toastTokens.animation.timing.default,
        enterStyle: {
            x: 0,
            y: toastTokens.animation.enterTransition.offset.start,
            opacity: (0,tokens/* getOpacityTokenValue */.vs)(toastTokens.animation.opacity.enter.start)
        },
        exitStyle: {
            x: 0,
            y: -(0,cjs.getTokenValue)(toastTokens.animation.exitTransition.end),
            opacity: (0,tokens/* getOpacityTokenValue */.vs)(toastTokens.animation.opacity.exit.end)
        },
        duration: duration,
        $largerThanSM: {
            borderRadius: toastTokens.radius.size.m,
            marginVertical: toastTokens.margin.topBottom.m,
            paddingVertical: toastTokens.padding.topBottom.m,
            paddingHorizontal: toastTokens.padding.leftRight.m
        },
        $largerThanMD: {
            borderRadius: toastTokens.radius.size.lAndXl,
            marginVertical: toastTokens.margin.topBottom.lAndXl,
            paddingVertical: toastTokens.padding.topBottom.lAndXl,
            paddingHorizontal: toastTokens.padding.leftRight.lAndXl
        },
        marginVertical: toastTokens.margin.topBottom.xsAndS,
        paddingVertical: toastTokens.padding.topBottom.xsAndS,
        paddingHorizontal: toastTokens.padding.leftRight.xsAndX,
        borderRadius: toastTokens.radius.size.sAndXs,
        backgroundColor: getBackgroundColor(),
        width: width,
        maxWidth: toastTokens.size.maxWidth,
        children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
            justifyContent: "space-between",
            analyticsName: "".concat(analyticsName, "-toast"),
            trackImpression: trackImpression,
            flexDirection: "row",
            alignItems: "center",
            children: [
                /* @__PURE__ */ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    tag: "span",
                    color: toastTokens.color.content.valueText.default,
                    typography: toastTokens.typography.valueText,
                    children: message
                }),
                /* @__PURE__ */ (0,jsx_runtime.jsx)(Toast.Close, {
                    asChild: !0,
                    children: /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* CloseButton */.PZ, {
                        analyticsName: "".concat(analyticsName, "-close"),
                        size: "small",
                        variant: "inverse"
                    })
                })
            ]
        })
    });
};



/***/ }),

/***/ 50379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Toggle; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Animated/index.js + 64 modules
var Animated = __webpack_require__(53089);
// EXTERNAL MODULE: ./node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(20129);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@tamagui/compose-refs/dist/esm/compose-refs.mjs
var compose_refs = __webpack_require__(94030);
// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs + 1 modules
var esm = __webpack_require__(75425);
// EXTERNAL MODULE: ./node_modules/@tamagui/helpers/dist/esm/index.mjs + 5 modules
var dist_esm = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/@tamagui/label/dist/esm/Label.mjs + 2 modules
var Label = __webpack_require__(65910);
// EXTERNAL MODULE: ./node_modules/@tamagui/use-previous/dist/esm/index.mjs
var use_previous_dist_esm = __webpack_require__(82375);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@tamagui/switch-headless/dist/esm/useSwitch.mjs







function getState(checked) {
  return checked ? "checked" : "unchecked";
}
const BubbleInput = props => {
  const {
      control,
      checked,
      bubbles = !0,
      ...inputProps
    } = props,
    ref = react.useRef(null),
    prevChecked = (0,use_previous_dist_esm/* usePrevious */.D)(checked);
  return react.useEffect(() => {
    const input = ref.current,
      inputProto = window.HTMLInputElement.prototype,
      setChecked = Object.getOwnPropertyDescriptor(inputProto, "checked").set;
    if (prevChecked !== checked && setChecked) {
      const event = new Event("click", {
        bubbles
      });
      setChecked.call(input, checked), input.dispatchEvent(event);
    }
  }, [prevChecked, checked, bubbles]),
  // @ts-ignore
  /* @__PURE__ */
  (0,jsx_runtime.jsx)("input", {
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: checked,
    ...inputProps,
    tabIndex: -1,
    ref,
    style: {
      ...props.style,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  });
};
function useSwitch(props, [checked, setChecked], ref) {
  const {
      disabled,
      name,
      value,
      required
    } = props,
    hasConsumerStoppedPropagationRef = react.useRef(!1),
    [button, setButton] = react.useState(null),
    composedRefs = (0,compose_refs/* useComposedRefs */.ex)(ref, setButton),
    isFormControl = esm/* isWeb */.$L ? button ? !!button.closest("form") : !0 : !1,
    labelId = (0,Label/* useLabelContext */.t0)(button),
    ariaLabelledBy = props["aria-labelledby"] || props.labeledBy || labelId;
  return {
    switchProps: {
      role: "switch",
      "aria-checked": checked,
      ...(esm/* isWeb */.$L ? {
        tabIndex: disabled ? void 0 : 0,
        "data-state": getState(checked),
        "data-disabled": disabled ? "" : void 0,
        disabled
      } : {}),
      ...props,
      "aria-labelledby": ariaLabelledBy,
      onPress: (0,dist_esm/* composeEventHandlers */.Mj)(props.onPress, event => {
        setChecked(prevChecked => !prevChecked), esm/* isWeb */.$L && isFormControl && (hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(), hasConsumerStoppedPropagationRef.current || event.stopPropagation());
      })
    },
    switchRef: composedRefs,
    /**
     * insert as a sibling of your switch (should not be inside the switch)
     */
    bubbleInput: esm/* isWeb */.$L && isFormControl ? /* @__PURE__ */(0,jsx_runtime.jsx)(BubbleInput, {
      control: button,
      bubbles: !hasConsumerStoppedPropagationRef.current,
      name,
      value,
      checked,
      required,
      disabled,
      style: {
        transform: "translateX(-100%)"
      }
    }) : null
  };
}

//# sourceMappingURL=useSwitch.mjs.map

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Toggle/Toggle.js










var toggleTokens = Components/* tokens.toggle */.T.toggle, Frame = (0,cjs.styled)(cjs.View, {
    // Use <button> tag for a11y so space/enter keys toggle the switch.
    // See: https://www.w3.org/WAI/ARIA/apg/patterns/switch/
    tag: "button",
    // @ts-expect-error - need type="button" to prevent form submission on web
    type: "button",
    padding: 0,
    flexDirection: "row",
    alignSelf: "flex-start",
    backgroundColor: toggleTokens.color.background.element.toggle.default,
    cursor: "pointer",
    borderStyle: "solid",
    borderWidth: toggleTokens.borderWidth.element.state.default,
    borderColor: toggleTokens.color.border.element.toggle.state.default,
    outlineStyle: "none",
    borderRadius: toggleTokens.cornerRadius.element.toggle.large,
    animation: "accelerateDecelerateFastest",
    animateOnly: cjs.isWeb ? [
        "background-color",
        "border-color"
    ] : [
        "backgroundColor",
        "borderColor"
    ],
    focusVisibleStyle: {
        borderColor: toggleTokens.color.border.element.toggle.state.focused
    },
    variants: {
        frameSize: function(size) {
            return {
                height: toggleTokens.size.element.onOff[size]
            };
        },
        hasError: {
            true: {
                borderColor: toggleTokens.color.border.element.toggle.state.error,
                "aria-invalid": !0
            }
        },
        disabled: {
            true: {
                cursor: "not-allowed",
                pointerEvents: "none"
            }
        },
        embedded: {
            true: {
                maxWidth: 80
            },
            false: {
                minWidth: 320
            }
        }
    }
}), Content = (0,cjs.styled)(cjs.View, {
    alignItems: "center",
    justifyContent: "center",
    variants: {
        frameSize: function(size) {
            return {
                width: 140,
                height: toggleTokens.size.element.onOff[size],
                borderRadius: toggleTokens.cornerRadius.element.toggle.large
            };
        },
        embedded: {
            true: {
                maxWidth: 40
            },
            false: {
                minWidth: 140
            }
        }
    }
}), Thumb = (0,cjs.styled)(cjs.View, {
    backgroundColor: toggleTokens.color.background.element.toggle.on,
    variants: {
        frameSize: function(size) {
            return {
                height: toggleTokens.size.element.onOff[size],
                borderRadius: toggleTokens.cornerRadius.element.toggle.large
            };
        },
        embedded: {
            true: {
                maxWidth: 80
            },
            false: {
                minWidth: 140
            }
        },
        hasError: {
            true: {
                backgroundColor: toggleTokens.color.background.element.toggle.state.errorOn
            }
        },
        disabled: {
            true: {
                backgroundColor: toggleTokens.color.background.element.toggle.state.inactiveOn
            }
        }
    }
}), Toggle = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var leftIcon = _param.leftIcon, rightIcon = _param.rightIcon, size = _param.size, hasError = _param.hasError, leftLabel = _param.leftLabel, rightLabel = _param.rightLabel, isEmbeddedInTextInput = _param.isEmbeddedInTextInput, props = (0,_object_without_properties/* default */.Z)(_param, [
        "leftIcon",
        "rightIcon",
        "size",
        "hasError",
        "leftLabel",
        "rightLabel",
        "isEmbeddedInTextInput"
    ]);
    var _$ref = (0,react.useState)(props.defaultChecked || !1), checked = _$ref[0], setChecked = _$ref[1], _$ref1 = useSwitch(props, [
        checked,
        setChecked
    ], ref), switchProps = _$ref1.switchProps, switchRef = _$ref1.switchRef, bubbleInput = _$ref1.bubbleInput, onCheckedChange = switchProps.onCheckedChange, restSwitchProps = (0,_object_without_properties/* default */.Z)(switchProps, [
        "onCheckedChange"
    ]);
    (0,react.useEffect)(function() {
        onCheckedChange === null || onCheckedChange === void 0 ? void 0 : onCheckedChange(checked);
    }, [
        checked
    ]);
    var animation = (0,react.useRef)(new Animated/* default.Value */.Z.Value(checked ? 1 : 0));
    (0,react.useEffect)(function() {
        Animated/* default.timing */.Z.timing(animation.current, {
            toValue: checked ? 1 : 0,
            duration: 80,
            useNativeDriver: !0
        }).start();
    }, [
        checked
    ]);
    var getIconColor = (0,react.useCallback)(function(isSelected) {
        return props.disabled ? isSelected ? toggleTokens.color.content.element.toggle.state.inactiveOn : toggleTokens.color.content.element.toggle.state.inactiveOff : hasError && !isSelected ? toggleTokens.color.content.element.toggle.state.error : isSelected ? toggleTokens.color.content.element.toggle.on : toggleTokens.color.content.element.toggle.off;
    }, [
        props.disabled,
        hasError
    ]), _$ref2 = (0,react.useState)(0), leftWidth = _$ref2[0], setLeftWidth = _$ref2[1], _$ref3 = (0,react.useState)(0), rightWidth = _$ref3[0], setRightWidth = _$ref3[1];
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsxs)(Frame, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: switchRef
            }, restSwitchProps), {
                disabled: !!switchProps.disabled,
                frameSize: size,
                hasError: hasError,
                embedded: isEmbeddedInTextInput,
                children: [
                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Animated/* default.View */.Z.View, {
                        style: [
                            {
                                position: "absolute",
                                width: checked ? rightWidth : leftWidth,
                                transform: [
                                    {
                                        translateX: animation.current.interpolate({
                                            inputRange: [
                                                0,
                                                1
                                            ],
                                            outputRange: [
                                                0,
                                                leftWidth
                                            ]
                                        })
                                    }
                                ]
                            }
                        ],
                        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Thumb, {
                            frameSize: size,
                            hasError: hasError,
                            disabled: props.disabled,
                            embedded: isEmbeddedInTextInput
                        })
                    }),
                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Content, {
                        frameSize: size,
                        embedded: isEmbeddedInTextInput,
                        onLayout: function(e) {
                            return setLeftWidth(e.nativeEvent.layout.width);
                        },
                        paddingHorizontal: leftLabel ? "$9x" : "$4x",
                        children: rightLabel ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            tag: "span",
                            typography: size === "small" ? toggleTokens.typography.element.smallSize : toggleTokens.typography.element.mediumSize,
                            color: getIconColor(!checked),
                            children: leftLabel
                        }) : (leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.Component) && /* @__PURE__ */ (0,jsx_runtime.jsx)(leftIcon.Component, {
                            "aria-label": leftIcon.label,
                            color: getIconColor(!checked)
                        })
                    }),
                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Content, {
                        frameSize: size,
                        embedded: isEmbeddedInTextInput,
                        onLayout: function(e) {
                            return setRightWidth(e.nativeEvent.layout.width);
                        },
                        paddingHorizontal: rightLabel ? "$9x" : "$4x",
                        children: rightLabel ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            tag: "span",
                            typography: size === "small" ? toggleTokens.typography.element.smallSize : toggleTokens.typography.element.mediumSize,
                            color: getIconColor(checked),
                            children: rightLabel
                        }) : (rightIcon === null || rightIcon === void 0 ? void 0 : rightIcon.Component) && /* @__PURE__ */ (0,jsx_runtime.jsx)(rightIcon.Component, {
                            "aria-label": rightIcon.label,
                            color: getIconColor(checked)
                        })
                    })
                ]
            })),
            bubbleInput
        ]
    });
});



/***/ }),

/***/ 70131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N7": function() { return /* binding */ observe; },
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, default, defaultFallbackInView */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var observerMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
var unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options, fallbackInView) {
  if (options === void 0) {
    options = {};
  }

  if (fallbackInView === void 0) {
    fallbackInView = unsupportedValue;
  }

  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    var bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return function () {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap["delete"](id);
    }
  };
}

var _excluded = ["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"];

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay,
        fallbackInView = _this$props.fallbackInView;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    }, fallbackInView);
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        props = _objectWithoutPropertiesLoose(_this$props2, _excluded);

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView,
      fallbackInView = _ref.fallbackInView;

  var unobserve = react__WEBPACK_IMPORTED_MODULE_0__.useRef();

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      }, fallbackInView);
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  /* eslint-disable-next-line */

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.m.js.map


/***/ }),

/***/ 31584:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

function cov_1vjsa3ppix() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronLeft.tsx";
  var hash = "632e5e0c3812891ff86b9e96289f50601a68a834";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronLeft.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "632e5e0c3812891ff86b9e96289f50601a68a834"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1vjsa3ppix = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1vjsa3ppix();
var Icon = (cov_1vjsa3ppix().s[0]++, {
  name: 'chevron-left',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow_back_ios\" d=\"M8.09035 12L15.623 19.5327C15.8218 19.7314 15.9186 19.9654 15.9134 20.2346C15.9083 20.5038 15.8064 20.7378 15.6076 20.9365C15.4089 21.1352 15.175 21.2346 14.9058 21.2346C14.6365 21.2346 14.4026 21.1352 14.2039 20.9365L6.5327 13.2808C6.3519 13.1 6.21792 12.8974 6.13075 12.6731C6.04358 12.4487 6 12.2244 6 12C6 11.7757 6.04358 11.5513 6.13075 11.3269C6.21793 11.1026 6.35192 10.9 6.5327 10.7193L14.2039 3.0481C14.4026 2.84938 14.6391 2.75258 14.9135 2.7577C15.1878 2.76283 15.4243 2.86476 15.623 3.06348C15.8218 3.26219 15.9211 3.49616 15.9211 3.76538C15.9211 4.03461 15.8218 4.26858 15.623 4.4673L8.09035 12Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ }),

/***/ 27959:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

function cov_kho02a6py() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Close.tsx";
  var hash = "1e89307570a95f6cedef1cd412978432b7d6505f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Close.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1e89307570a95f6cedef1cd412978432b7d6505f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_kho02a6py = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_kho02a6py();
var Icon = (cov_kho02a6py().s[0]++, {
  name: 'close',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M12 13.0538L6.92689 18.1269C6.78844 18.2654 6.6144 18.3362 6.40479 18.3394C6.19519 18.3426 6.01795 18.2718 5.87309 18.1269C5.7282 17.982 5.65576 17.8064 5.65576 17.6C5.65576 17.3936 5.7282 17.218 5.87309 17.0731L10.9462 12L5.87309 6.92689C5.73462 6.78844 5.66379 6.6144 5.66059 6.40479C5.65737 6.19519 5.7282 6.01795 5.87309 5.87309C6.01795 5.7282 6.19359 5.65576 6.39999 5.65576C6.60639 5.65576 6.78202 5.7282 6.92689 5.87309L12 10.9462L17.0731 5.87309C17.2115 5.73462 17.3856 5.66379 17.5952 5.66059C17.8048 5.65737 17.982 5.7282 18.1269 5.87309C18.2718 6.01795 18.3442 6.19359 18.3442 6.39999C18.3442 6.60639 18.2718 6.78202 18.1269 6.92689L13.0538 12L18.1269 17.0731C18.2654 17.2115 18.3362 17.3856 18.3394 17.5952C18.3426 17.8048 18.2718 17.982 18.1269 18.1269C17.982 18.2718 17.8064 18.3442 17.6 18.3442C17.3936 18.3442 17.218 18.2718 17.0731 18.1269L12 13.0538Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ })

}]);